<div class="margin">
    <div class="flash-message-container">
      <flash-message></flash-message>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="page-header">
          <h2>{{safra.id ? 'Editando' : 'Nova'}} Safra</h2>
        </div>
      </div>
  
      <div class="col-xs-12">
        <form id="safra_form" name="safra_form" novalidate ng-submit="save(safra_form)">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" ng-class="{'has-error': safra_form.descricao.$invalid}">
                <label for="descricao">Descrição</label>
                <input autofocus class="form-control" ng-model="safra.descricao" type="text" id="descricao" name="descricao" autocomplete="off" required>
              </div>
            </div>
            <div class="col-xs-6 col-md-6">
              <div class="form-group" ng-class="{'has-error': safra_form.data_inicial.$invalid || data_inicial_invalida}">
                <label for="data_inicial">Data Inicial:</label>
                <div class="input-group">
                  <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data"
                    uib-datepicker-popup="dd/MM/yyyy" ng-model="safra.data_inicial" id="data_inicial" name="data_inicial" required
                    is-open="popupDataInicial.opened" show-button-bar="false" datepicker-append-to-body="true">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-click="popupDataInicial.opened = !popupDataInicial.opened">
                      <i class="glyphicon glyphicon-calendar"></i>
                    </button>
                  </span>
                </div>
                <span class="help-block" ng-if="data_inicial_invalida">A data inicial não pode ser maior que a data final!</span>
              </div>
            </div>
            <div class="col-xs-6 col-md-6">
                <div class="form-group" ng-class="{'has-error': safra_form.data_final.$invalid}">
                  <label for="data_final">Data Término:</label>
                  <div class="input-group">
                    <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data"
                      uib-datepicker-popup="dd/MM/yyyy" ng-model="safra.data_final" id="data_final" name="data_final" required
                      is-open="popupDataFinal.opened" show-button-bar="false" datepicker-append-to-body="true">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default" ng-click="popupDataFinal.opened = !popupDataFinal.opened">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                </div>
            </div>
          </div>
          <div class="row pull-right padding-top-10">
            <div class="col-xs-12 btn-group">
              <button class="btn btn-default btn-sm btn-action" type="button" ng-click="goToIndex()">Cancelar</button>
  
              <button class="btn btn-success btn-sm btn-action" type="submit"
                      ng-disabled="safra_form.$invalid">
                Salvar <i class="fa fa-check"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  